/* eslint-disable */
import parseISO from "date-fns/parseISO";
import { parseVideo, Video } from "../../common/video/models/Video";

export interface SceneHighlight {
  textHighlights: string[];
  startMillis: number;
  thumbnailId: number;
}

export interface CommentHighlight {
  textHighlights: string[];
  created: Date;
}

export interface SearchHiglightSet {
  videoId: number;
  titleHighlights: string[];
  descriptionHighlights: string[];
  presenterHighlights: string[];
  sceneHighlights: SceneHighlight[];
  commentHighlights: CommentHighlight[];
}

export interface SearchHit {
  video: Video;
  highlights: SearchHiglightSet;
}

export type AggregationType = "createdYears" | "presenters" | "tags";

export interface Aggregation {
  facet: string;
  count: number;
}

export interface AggregationGroup<T extends AggregationType> {
  aggregations: Aggregation[];
  category: T;
}

export interface AggregationGroupSet {
  createdYears: AggregationGroup<"createdYears">;
  presenters: AggregationGroup<"presenters">;
  tags: AggregationGroup<"tags">;
}

export interface SearchResult {
  aggregationGroups: AggregationGroupSet;
  searchHits: SearchHit[];
}

function parseCommentHighlights(json: any): CommentHighlight {
  return {
    ...json,
    created: parseISO(json.created),
  };
}

function parseSearchHit(json: any): SearchHit {
  return {
    ...json,
    video: parseVideo(json.video),
    highlights: {
      ...json.highlights,
      commentHighlights: json.highlights.commentHighlights.map(
        parseCommentHighlights
      ),
    },
  };
}

function parseAggregationGroup<T extends AggregationType>(
  groupsJson: any,
  category: T,
  categoryKey: string = category
): AggregationGroup<T> {
  return {
    category,
    aggregations:
      groupsJson.find((g: any) => g.category === categoryKey).aggregations ||
      [],
  };
}

export function parseSearchResult(json: any): SearchResult {
  return {
    ...json,
    aggregationGroups: {
      createdYears: parseAggregationGroup(
        json.aggregationGroups,
        "createdYears",
        "created_years"
      ),
      presenters: parseAggregationGroup(json.aggregationGroups, "presenters"),
      tags: parseAggregationGroup(json.aggregationGroups, "tags"),
    } as AggregationGroupSet,
    searchHits: json.searchHits.map(parseSearchHit),
  };
}
